import moment from 'moment';
import * as yup from 'yup';
const { yupResolver } = require('@hookform/resolvers/yup');

export const EMissionMemberType = [
  { label: 'ทั้งหมด', value: 'All' },
  { label: 'เฉพาะนักธุรกิจ', value: 'Distributor' },
  { label: 'เฉพาะ VIP', value: 'Member' },
  { label: 'เฉพาะรายชื่อ', value: 'Group' },
];

export const legacyMissionFormDefaultValues = {
  title: '',
  description: '',
  image: '',
  point: 0,
  startDate: moment(),
  endDate: moment(),
  memberType: 'All',
};

export const legacyMissionFormSchema = () => {
  return yupResolver(
    yup.object().shape({
      title: yup.string().required('กรุณากรอกข้อมูล'),
      description: yup.string().defined(),
      image: yup.string().defined(),
      point: yup
        .number()
        .min(1, 'กรุณากรอกข้อมูล')
        .typeError('กรุณากรอกข้อมูล')
        .required('กรุณากรอกข้อมูล'),
      startDate: yup.string().required('กรุณากรอกข้อมูล'),
      endDate: yup.string().required('กรุณากรอกข้อมูล'),
      memberType: yup.string().required('กรุณากรอกข้อมูล'),
    }),
  );
};
